define([], function() {
  var Tags = function () {};

  Tags.prototype.actionIndex = function() {
    $('.add-tag').on('click', function(e) {
      e.preventDefault();
      $('<div class="form-group"><input class="form-control half" type="text" name="tags[]" id="tag_name" placeholder="Tag"><i class="fa fa-times remove-tag"></i></div>').insertBefore($('form .form-actions'));
      $('.section-add-tag .save-tags').show();
    });

    $('body').on('click', '.remove-tag', function() {
      $(this).parent().remove();
      if ($('.section-add-tag .form-group').length == 0) {
        $('.save-tags').hide();
      }
    });
  };

  return Tags;
});
